import { CmsImage } from '@zoopla/cms/image';
import { ContentfulImage } from '../graphql.generated';
import {
    heading,
    logoCollectionContainer,
    unorderedList
} from './cms-logo-collection.styles.css';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';

export interface CmsLogoCollectionProps {
    title: string;
    logos: ContentfulImage[];
}

function CmsLogoCollection({ title, logos }: CmsLogoCollectionProps) {
    return (
        <div className={logoCollectionContainer}>
            <h2 className={`${fontGroups.plate} ${heading}`}>{title}</h2>
            {logos.length > 0 && (
                <ul className={unorderedList}>
                    {logos.map((logo: ContentfulImage, index: number) => (
                        <li key={index}>
                            <CmsImage src={logo.url} alt={logo.altText ?? ''} />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default CmsLogoCollection;
